<script>
  export let data;
  let focus = false;
  $: result = [];
  $: attributes = { name: data.key };
</script>

<div class="input-select">
  {#if data.type === 'select' || data.type === 'multiselect'}
    <!-- svelte-ignore a11y-click-events-have-key-events  -->
    <!-- svelte-ignore a11y-no-noninteractive-element-interactions-->

    <div data-open={focus} data-focus={focus || !!result[0]}>
      <label
        on:click={e => e.target.parentNode?.tagName.toLowerCase() === 'label' && (focus = !focus)}
        aria-label={data.placeholder}>
        <input {...attributes} type="text" value={JSON.stringify(result)} />
      </label>
      {#each result as value, i}
        <button type="button" on:click={e => (result = result.filter((_, j) => j !== i))}>
          {value.header} <span /></button>
      {/each}
    </div>
    <menu style="display:{focus && result.length < data.options.length ? 'flex' : 'none'}">
      {#each data.options as option}
        <button
          type="button"
          style="display:{result.includes(option) ? 'none' : 'flex'}"
          on:click={e => {
            if (data.type === 'multiselect') result = [...result, option];
            else (result = [option]), (focus = false);
            if (data.options.length === result.length) focus = false;
          }}>{option.header}</button>
      {/each}
    </menu>
  {:else if data.type === 'input'}
    <input
      type="text"
      bind:value={result[0]}
      on:blur={() => (focus = false)}
      on:focus={() => (focus = true)}
      data-focus={focus || !!result[0]}
      aria-label={data.placeholder}
      list={data.key + '-datalist'}
      {...attributes} />
    <datalist id={data.key + '-datalist'}>
      {#each data.options as option}
        <option>{option.header}</option>
      {/each}
    </datalist>
  {/if}
  <span>
    {data.placeholder}
  </span>
  {#if data.required}
    <strong>*</strong>
  {/if}
</div>

<style lang="scss">
  div > div {
    position: relative;
    display: inline-flex;
    flex-wrap: wrap;
    gap: 5px;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    min-height: 60px;
    padding: 16px 24px 14px;
    color: #2c333c;
    font-weight: 600;
    font-size: 16px;
    font-family: Vela Sans;
    font-style: normal;
    line-height: 26px;
    background: #fff;
    border: 2px solid rgb(119 129 143 / 45%);
    border-radius: 5px;
    resize: none !important;

    label {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      transform: scale(1) !important;

      input {
        display: none;
      }
    }

    &[data-open='true'] {
      border-bottom-right-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }

    button {
      z-index: 3;
      display: inline-flex;
      gap: 10px;
      align-items: center;
      justify-content: center;
      padding: 5px 15px;
      color: #fff;
      background: #22eaac;
      border-radius: 5px;

      > span {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15px;
        height: 15px;

        &::after,
        &::before {
          position: absolute;
          width: 4px;
          height: 100%;
          background: #fff;
          content: '';
        }

        &::after {
          transform: rotate(45deg);
        }

        &::before {
          transform: rotate(-45deg);
        }
      }
    }
  }

  menu {
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    background: #fff;
    border: 2px solid rgb(119 129 143 / 45%);
    border-top: none;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;

    button {
      width: 100%;
      padding: 13px 22px;
      color: #2c333c;
      font-weight: 600;
      font-size: 16px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 26px;
      transform: scale(1) !important;
      cursor: copy;
    }
  }
</style>
